// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest, OPS_UPLOAD_TIMEOUT } from "apis/AdminOpsApiCommon";

// 運営ツール: 外見動画の追加（idle / talk。任意の動画は AssetUpload で1本ずつ追加する）
const AdminOpsAppearanceAddApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_appearance_add";

    const ExecAdminOpsAppearanceAddApi = async ({ name, tVoiceTypeId, idleFile, talkFile }, onUploadProgress = null) => {
        const requestParams = { name: name, t_voice_type_id: tVoiceTypeId };
        const requestBinaryParams = {
            idle_file: { file: idleFile, filename: idleFile.name },
            talk_file: { file: talkFile, filename: talkFile.name },
        };
        return ExecOpsRequest(dispatch, { url: url, requestParams: requestParams, requestBinaryParams: requestBinaryParams, timeout: OPS_UPLOAD_TIMEOUT, onUploadProgress: onUploadProgress });
    };

    return ExecAdminOpsAppearanceAddApi;
};

export default AdminOpsAppearanceAddApi;
